module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/covid.e36eb87a.png";